module.exports = __webpack_public_path__ + "img/Slice 268@2x.f28c7e1b.png";